import { defineDocument } from '../../schema';
export const blogExtraExtraReadAllAboutWtfIsHappeningDocument = defineDocument({
    id: 'blog:extra-extra-read-all-about-wtf-is-happening',
    kind: 'blog',
    slug: 'extra-extra-read-all-about-wtf-is-happening',
    route: '/blog/extra-extra-read-all-about-wtf-is-happening',
    seo: {
        title: 'Extra! Extra! Read All About WTF Is Happening',
        description: 'Stop the presses: our latest game is making headlines',
        imageAsset: 'coverWTFIsHappening',
    },
    hero: {
        eyebrow: [
            {
                type: 'text',
                text: 'Airhead Blog',
            },
        ],
        title: [
            {
                type: 'text',
                text: 'Extra! Extra! Read All About WTF Is Happening',
            },
        ],
        description: [
            {
                type: 'text',
                text: 'Stop the presses: our latest game is making headlines',
            },
        ],
        imageAsset: 'coverWTFIsHappening',
        imageAlt: 'WTF Is Happening cover art',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2025-10-16T00:00:00.000Z'),
        tags: ['games'],
    },
    sections: [
        {
            id: 'article',
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: "Most games use room codes just to get you into a lobby. At Airhead Games, we've decided those random letter combinations should be the main event. ",
                        },
                        {
                            type: 'link',
                            href: '/discover/games/wtf-is-happening',
                            children: [
                                {
                                    type: 'text',
                                    text: 'WTF Is Happening',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: ' officially joins our lineup today, challenging you to take three-letter acronyms and turn them into unhinged viral news stories.',
                        },
                    ],
                },
            ],
            sections: [
                {
                    id: 'article__beyond-the-acronym',
                    title: [
                        {
                            type: 'text',
                            text: 'Beyond the Acronym',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "The spark for WTF Is Happening came from Josh, a longtime friend of Airhead Games, who grew up playing acronym games that turned letters into silly phrases. We loved the simplicity, but wanted to expand on the concept. That's how ",
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'The Airhead Times',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' was born.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Each round, a player selects a newspaper section like "Sports" or "Obituaries." Reporters are then put on a strict deadline to pitch a headline to the Editor-in-Chief. What starts as a nonsensical acronym eventually transforms into a full-page newspaper spread, complete with a story and an accompanying photo to match your winning pitch.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__a-masterpiece-in-every-edition',
                    title: [
                        {
                            type: 'text',
                            text: 'A Masterpiece in Every Edition',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "One of the biggest design challenges wasn't the game mechanics, but perfecting the big story reveal. After the winning headline is chosen, we show the scores to allow enough time to generate the custom story and image to match the headline.",
                                },
                            ],
                        },
                        {
                            type: 'quote',
                            content: [
                                {
                                    type: 'text',
                                    text: 'The Airhead Times is really giving The Onion a run for their money.',
                                },
                            ],
                            attribution: [
                                {
                                    type: 'text',
                                    text: 'Beta Tester',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Some players might miss it in the heat of the newsroom, but the hard-hitting facts are that every story is always unique to your group’s headline. We’re not using static content: all newspaper sections, stories, and images are generated fresh every single time you play, ensuring no two editions of the paper are ever the same.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__refining-the-reporter-experience',
                    title: [
                        {
                            type: 'text',
                            text: 'Refining the Reporter Experience',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'During early playtests, we realized that the English language can be a bit of a bully. A purely random letter generator gave us way too many "X" and "Z" prompts, which led to more frustration than laughs.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "To fix this, we rebuilt the logic to weight letters in a way more representative of how words realistically begin in the English language. It's a subtle bit of polish that makes the game feel more accessible to the average wordsmith. We're planning to bring this same level of fine-tuning to other languages once we localize our games.",
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__speed-vs-quality',
                    title: [
                        {
                            type: 'text',
                            text: 'Speed vs. Quality',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'The newspaper theme lent itself well to something real reporters are all-too-familiar with: deadlines. Introducing a speed bonus was the perfect way to keep up the pace of the game and incentivize quick creativity. While points for votes still carry the heaviest weight, the speed bonus can be a crucial tiebreaker in close matches. You have to decide: do you submit a good-enough headline to snag a higher speed bonus, or take your time to craft a masterpiece that might sweep the votes?',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__join-the-newsroom',
                    title: [
                        {
                            type: 'text',
                            text: 'Join the Newsroom',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "We want to see the absolute nonsense you're printing in ",
                                },
                                {
                                    type: 'link',
                                    href: 'https://discord.gg/rfFTVAqHwH',
                                    children: [
                                        {
                                            type: 'text',
                                            text: "Poppy's Pals Discord",
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '. Share your fake news, bug reports, and let us know WTF Is Happening in your world.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Have what it takes to become the next ace reporter at the Airhead Times? ',
                                },
                                {
                                    type: 'link',
                                    href: '/library',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Play WTF Is Happening now.',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'article-actions',
            widgets: [
                {
                    type: 'relatedDocuments',
                    limit: 4,
                },
            ],
        },
    ],
});
//# sourceMappingURL=extra-extra-read-all-about-wtf-is-happening.js.map